import LeadsDetails from "../../components/leads/[id]/LeadsDetails";


const LeadsDetailsPage = () => {
  return <LeadsDetails />;
};

export default LeadsDetailsPage;
